// In milliseconds
export const time = {
  get eighteenYearsAgo() {
    return new Date().setFullYear(new Date().getFullYear() - 18);
  },
};
